import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

const colorGreen = '#19a15f';
const colorYellow = '#ffcd43';
const colorRed = '#dd5347';

export const StockDot = styled.span`
  margin-right: ${rem(8)};

  &:after {
    content: '●';
  }
`;

export const StockDotGreen = styled(StockDot)`
  color: ${colorGreen};
`;

export const StockDotYellow = styled(StockDot)`
  color: ${colorYellow};
`;

export const StockDotRed = styled(StockDot)`
  color: ${colorRed};
`;
